module.exports = __webpack_public_path__ + "static/media/DigiNanny for Cities.46618711.png";